import {
  GET_SYSTEMS,
  GET_SYSTEM_DETAILS,
  FILTER_SYSTEMS,
  SORT_SYSTEMS,
  GET_SYSTEMS_BULK,
} from "../actions";

import { API } from "@aws-amplify/api";
import config from "../../../aws-exports.js";
import { getFromServer } from "../../global/middleware";

API.configure(config);

let questObject;
let getResult;
let systemsToExport;
let headers;

export function systemMiddleware({ dispatch }) {
  return function (next) {
    return async function (action) {
      //TODO: Error handling
      switch (action.type) {
        case FILTER_SYSTEMS:
          break;
        case SORT_SYSTEMS:
          break;
        case GET_SYSTEMS:
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "systems";

          getResult = await getFromServer(questObject);
          if (getResult.responseCode < 202 && getResult !== 0) {
            action.results = getResult.results;
          } else {
            action.errors = { responseCode: getResult.responseCode };
            console.log("action.errors", action.errors, "getResult", getResult);
          }
          break;
        case GET_SYSTEM_DETAILS:
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "systems";

          getResult = await getFromServer(questObject);
          if (getResult.responseCode < 202 && getResult !== 0) {
            action.results = getResult.results;
          } else {
            action.errors = { responseCode: getResult.responseCode };
            console.log("action.errors", action.errors, "getResult", getResult);
          }
          break;
        case GET_SYSTEMS_BULK:
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "bulkSystems";

          let bulkResult = await getFromServer(questObject);
          break;
      }
      return next(action);
    };
  };
}
